import { RoutingPattern } from '../../Routes';

export const getApiReferenceUrl = (category: string) =>
    [RoutingPattern.apiReference, category].join('/');
